var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.ConfigurationVariables", function(busy, octopusRepository) {
    return {
      title: "Configuration variables",
      description: "Replace settings in any _.config_ files with variables defined in Octopus.",
      editTemplateUrl: "areas/projects/features/Octopus.Features.ConfigurationVariables_edit.html",
      priority: 20,
      editLink: function($scope, element) {
      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] = "True";
      },
      disable: function(action, step) {
        delete action.Properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"];
      }
    };
  });

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.ConfigurationVariables.js
// module id = 2501197238356793
// module chunks = 1